import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

// Bootstraps a tenant session from a short-lived admin "view as" token (opened
// in a fresh tab) and hands off to the normal tenant portal — lets support
// staff see exactly what a given tenant sees, without needing their OTP.
export default function AdminViewAs() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const phone = params.get('phone');
    const projectName = params.get('projectName');
    if (!token || !phone || !projectName) { navigate('/portal'); return; }

    localStorage.setItem('tenantToken', token);
    localStorage.setItem('tenantPhone', phone);
    localStorage.setItem('tenantName', params.get('name') || '');
    localStorage.setItem('tenantProject', projectName);
    localStorage.setItem('tenantProjects', JSON.stringify([projectName]));
    localStorage.setItem('tenantBuildingAddress', params.get('buildingAddress') || '');
    localStorage.setItem('tenantBuildingFull', `${params.get('buildingAddress') || ''} ${params.get('buildingNumber') || ''}`.trim());
    localStorage.setItem('tenantApartmentNumber', params.get('apartmentNumber') || '');
    localStorage.setItem('tenantBAddr', params.get('buildingAddress') || '');
    localStorage.setItem('tenantBNum', params.get('buildingNumber') || '');
    localStorage.setItem('tenantAptNum', params.get('apartmentNumber') || '');
    localStorage.setItem('tenantMultiApt', '0');
    localStorage.setItem('tenantTab', 'home');
    // Lets the activity dashboard tell a real tenant visit apart from an admin
    // just previewing what that tenant sees — this browsing shouldn't show up
    // as if the tenant themselves were active.
    localStorage.setItem('tenantIsAdminPreview', '1');

    navigate(`/portal/${encodeURIComponent(projectName)}`, { replace: true });
  }, [params, navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', direction: 'rtl', color: '#6b7280', fontFamily: 'system-ui' }}>
      טוען תצוגת דייר...
    </div>
  );
}
